/** Genel özet tablosunun rakam hücresi: para birimi yok (başlıkta yazar); tam sayı tutarda kuruş yok ("1.570"), kuruşluda iki hane. */
export function sayiYaz(minor: number): string {
  const tam = minor % 100 === 0;
  return (minor / 100).toLocaleString('tr-TR', { minimumFractionDigits: tam ? 0 : 2, maximumFractionDigits: tam ? 0 : 2 });
}

